import CardIcon from '../../components/shared/card/CardIcon';
import React from 'react';
import styled from 'styled-components';
import Button from '../../components/shared/Button';

const Message = styled.div`
  padding: 20px 0 0;
  font-weight: 300;
  font-size: 1.4rem;
`;

const ServiceName = styled.div`
  padding: 40px 10px 0;
  font-size: 1.8rem;
  font-weight: 500;
`;

const ClosedRound = props => {
  return (
    <CardIcon
      icon={props.icon}
      textAlign={'center'}
      padding={'20px'}
      logoBorderRadius={'50%'}
      theme={props.theme}
    >
      <ServiceName>{props.name}</ServiceName>
      <Message>
        <p>{props.t('round_closed')}</p>
      </Message>

      <Button btntype={'primary'} onClick={props.onRefresh} margin={'30px auto 0'}>
        {props.t('btn_refresh')}
      </Button>
    </CardIcon>
  );
};

export default ClosedRound;
